import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import { StyledCurrentTime } from './style'
import { fetchCurrentTimeStart  }  from '../../services/store/reducers/endpoints/currentTime'
import Clock from 'react-live-clock'

class CurrentTime extends PureComponent { 
  
  UNSAFE_componentWillMount () {
    this.props.fetchCurrentTimeStart()
    setInterval(() => {
      this.props.fetchCurrentTimeStart()
    }, (3600 * 6)) // 6 horas
  }
  render() {
    const {sagaCurrentTime} = this.props
    let seila = new Date(sagaCurrentTime)
    
    seila.setHours(seila.getHours() + 3)
    console.log('----', seila, seila.getFullYear())
    
    //let data = sagaCurrentTime ? sagaCurrentTime.split('-') : []
    let dataShow = ""
    let timeShow = ""
    //if(data.length > 0){
      let meses = seila.getMonth() + 1
      meses = meses.toString().length === 1 ? '0' + meses : meses

      let day = seila.getDate()
      day = day.toString().length === 1 ? '0' + day : day
      dataShow = day + '/' + meses + '/' + seila.getFullYear()
      //

      //timeShow =  <Clock date={sagaCurrentTime} format={'HH:mm:ss'} ticking={true} timezone={Intl.DateTimeFormat().resolvedOptions().timeZone} />
      timeShow=  <Clock date={sagaCurrentTime} format={'HH:mm:ss'} ticking={true} timezone={'Coordinated Universal Time'} />

    //}
    return (
      <StyledCurrentTime>
        { sagaCurrentTime && dataShow + ' ' } {timeShow}
      </StyledCurrentTime>
    )
  }
}


const mapStateToProps = state => ({
  
  sagaCurrentTime: state.sagaCurrentTime.data
})

const mapDispatchToProps = dispatch => ({
  fetchCurrentTimeStart: () => dispatch(fetchCurrentTimeStart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentTime)